

























































































import Vue from "vue";
import VaCard from "@/components/molecules/VaCard.vue";
import VaButton from "@/components/atoms/VaButton.vue";
import { ReleaseNotes } from "@/models/releaseNotes";

export default Vue.extend({
  name: "TrialStepDownloadAndroid",
  components: { VaCard, VaButton },
  computed: {
    links() {
      const links = this.$store.getters["cms/directLinks"];
      if (!Array.isArray(links)) return links;
      const priority = (title: string): number => {
        const t = title.toLowerCase();
        if (t.includes("play")) return 0;
        if (t.includes("neat")) return 1;
        if (t.includes("fire")) return 2;
        if (t.includes("apk")) return 3;
        return 4;
      };
      return [...links].sort((a, b) => priority(a.title) - priority(b.title));
    },
    controllerIos(): ReleaseNotes | undefined {
      const notes: ReleaseNotes[] = this.$store.getters["cms/releaseNotes"];
      return notes.find(
        (note) => note.product === "controller" && note.os === "ios"
      );
    },
    controllerAndroid(): ReleaseNotes | undefined {
      const notes: ReleaseNotes[] = this.$store.getters["cms/releaseNotes"];
      return notes.find(
        (note) => note.product === "controller" && note.os === "android"
      );
    },
  },
  async created() {
    this.$store.dispatch("cms/fetchDirectLinks");
    this.$store.dispatch("cms/fetchReleaseNotes");
  },
  methods: {},
});
